import { render, staticRenderFns } from "./BoxPlus.vue?vue&type=template&id=34e9ec78&scoped=true"
import script from "./BoxPlus.vue?vue&type=script&lang=js"
export * from "./BoxPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e9ec78",
  null
  
)

export default component.exports